module.exports = __webpack_public_path__ + "img/logo.ce6df184.png";